import { EmptyState } from '@app/components/base/EmptyState';
import { defineMessage, FormattedMessage } from 'react-intl';

const emptyDraftTabMessage = defineMessage({
  id: 'videoEditions.emptyDraftTab',
  defaultMessage: 'No hay borradores ni renders en curso en esta sección',
});

const emptyGeneratedTabMessage = defineMessage({
  id: 'videoEditions.emptyGeneratedTab',
  defaultMessage: 'Todavía no hay videos generados',
});

export interface VideoEditionsTabSegmentEmptyProps {
  variant: 'draft' | 'generated';
}

/**
 * Empty placeholder for a chip section (drafts vs generated) when that bucket has no cards.
 */
export function VideoEditionsTabSegmentEmpty({ variant }: VideoEditionsTabSegmentEmptyProps) {
  return (
    <EmptyState
      centered
      message={false}
      help={
        variant === 'draft' ? (
          <FormattedMessage {...emptyDraftTabMessage} />
        ) : (
          <FormattedMessage {...emptyGeneratedTabMessage} />
        )
      }
    />
  );
}
